import { render, staticRenderFns } from "./ManualAggregationView.vue?vue&type=template&id=0340bdbd&scoped=true"
import script from "./ManualAggregationView.vue?vue&type=script&lang=js"
export * from "./ManualAggregationView.vue?vue&type=script&lang=js"
import style0 from "./ManualAggregationView.vue?vue&type=style&index=0&id=0340bdbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0340bdbd",
  null
  
)

export default component.exports